import Fetch from 'utils/fetch'

export const findReleaseVersion = (qtRegsPerPage, page) => {
    return Fetch.get(`/releaseVersion/${qtRegsPerPage}/${page}`).then(({ data }) => data)
}

export const deleteReleaseVersion = (idReleaseVersion) => {
    return Fetch.delete(`/releaseVersion/${idReleaseVersion}`)
}